module.exports = {
	"id": "na",
	"name": "North America",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.017511,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.011674,
			"19": null,
			"20": null,
			"21": 0.011674,
			"22": 0.017511,
			"23": 0.005837,
			"24": null,
			"25": null,
			"26": 0.005837,
			"27": 0.005837,
			"28": null,
			"29": 0.017511,
			"30": null,
			"31": 0.035022,
			"32": 0.011674,
			"33": 0.017511,
			"34": 0.029185,
			"35": 0.017511,
			"36": 0.023348,
			"37": 0.035022,
			"38": 0.040859,
			"39": 0.046696,
			"40": 0.052533,
			"41": 0.075881,
			"42": 0.052533,
			"43": 0.245154,
			"44": 0.105066,
			"45": 0.087555,
			"46": 0.075881,
			"47": 0.075881,
			"48": 0.215969,
			"49": 1.371695,
			"50": 0.23348,
			"51": 0.852202,
			"52": 0.951431,
			"53": 20.943156,
			"54": 5.130723,
			"55": 0.052533,
			"56": 0.035022,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.017511,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.011674,
			"12": 0.005837,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.011674,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": 0.005837,
			"22": null,
			"23": null,
			"24": 0.011674,
			"25": 0.005837,
			"26": null,
			"27": 0.005837,
			"28": 0.017511,
			"29": 0.011674,
			"30": 0.005837,
			"31": 0.029185,
			"32": 0.005837,
			"33": 0.011674,
			"34": 0.011674,
			"35": 0.023348,
			"36": 0.023348,
			"37": 0.017511,
			"38": 0.087555,
			"39": 0.070044,
			"40": 0.064207,
			"41": 0.070044,
			"42": 0.064207,
			"43": 0.140088,
			"44": 0.052533,
			"45": 0.221806,
			"46": 0.128414,
			"47": 0.472797,
			"48": 0.548678,
			"49": 4.984798,
			"50": 0.046696,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": 0.017511
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.011674,
			"37": 0.023348,
			"38": 0.081718,
			"39": 0.011674,
			"40": 0.17511,
			"41": 0.029185,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.023348
		},
		"safari": {
			"0": null,
			"4": 0.023348,
			"5": 0.052533,
			"6": 0.017511,
			"7": 0.093392,
			"8": 0.256828,
			"9": 0.367731,
			"10": 2.142179,
			"3.1": null,
			"3.2": null,
			"5.1": 0.140088,
			"6.1": 0.215969,
			"7.1": 0.05837,
			"9.1": 2.247245
		},
		"ios_saf": {
			"8": 0,
			"10": 13.0164730641,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.350778887386,
			"8.1-8.4": 0.648049130933,
			"9.0-9.2": 0.309161053289,
			"9.3": 4.71668786428
		},
		"android": {
			"3": 0,
			"4": 0.0259721705426,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00324652131783,
			"4.1": 0.0936853294574,
			"4.2-4.3": 0.234213323643,
			"4.4": 0.537067383721,
			"4.4.3-4.4.4": 0.541705271318
		},
		"ie": {
			"6": 0.0353742327586,
			"7": 0.0412699382184,
			"8": 0.347846622126,
			"9": 0.353742327586,
			"10": 0.365533738506,
			"11": 7.05715943534,
			"5.5": null
		},
		"op_mob": {
			"0": 0.030998433182,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00086106758839
		},
		"edge": {
			"12": 0.081718,
			"13": 0.501982,
			"14": 2.235571
		},
		"ie_mob": {
			"10": 0.0664747605634,
			"11": 0.270647239437
		},
		"bb": {
			"7": 0.0593085,
			"10": null
		},
		"samsung": {
			"0": 2.95502
		},
		"and_uc": {
			"0": 0.466144
		},
		"op_mini": {
			"0": 0.41763649923
		},
		"and_chr": {
			"0": 18.687957
		},
		"and_ff": {
			"0": 0.054106
		}
	},
	"total": 98.5874147945
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/alt-na.json
 ** module id = 693
 ** module chunks = 0
 **/